import { Zap } from "lucide-react";
import { BENEFITS } from "@/lib/api";

export const Marquee = ({ items = BENEFITS, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-[#0B2A6F]/15 bg-lime-400 py-6 ${className}`} data-testid="benefits-marquee">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-3xl font-extrabold tracking-tight text-[#050B1F] sm:text-5xl">{t}</span>
                <Zap className="h-7 w-7 text-[#0B2A6F]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
